import { FC, SVGProps } from 'react';

export const ItalicIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12.3929 5C12.3929 4.58579 12.7286 4.25 13.1429 4.25H26C26.4142 4.25 26.75 4.58579 26.75 5C26.75 5.41421 26.4142 5.75 26 5.75H20.2618C20.1751 5.75 20.0983 5.80581 20.0716 5.88824L13.5456 25.9882C13.5037 26.1175 13.6 26.25 13.7358 26.25H18.1429C18.5571 26.25 18.8929 26.5858 18.8929 27C18.8929 27.4142 18.5571 27.75 18.1429 27.75H6C5.58579 27.75 5.25 27.4142 5.25 27C5.25 26.5858 5.58579 26.25 6 26.25H11.7382C11.8249 26.25 11.9017 26.1942 11.9284 26.1118L18.4544 6.01176C18.4963 5.88255 18.4 5.75 18.2642 5.75H13.1429C12.7286 5.75 12.3929 5.41421 12.3929 5Z"
			fill="currentColor"
		/>
	</svg>
);
